import { Component, input, InputSignal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
})
export class InputComponent {
  readonly label: InputSignal<string> = input<string>();
  readonly placeholder: InputSignal<string> = input<string>();
  readonly formControlRef: InputSignal<FormControl> = input<FormControl>();
  readonly email: InputSignal<boolean> = input<boolean>();
  readonly mask: InputSignal<string> = input<string>();
  readonly icon: InputSignal<string> = input<string>();
  readonly required: InputSignal<boolean> = input<boolean>();
  readonly id: InputSignal<string> = input<string>();
  readonly type: InputSignal<string> = input<string>();

  readonly appearance: InputSignal<MatFormFieldAppearance> =
    input<MatFormFieldAppearance>('outline');
  readonly dropSpecialCharacters: InputSignal<boolean> = input<boolean>(true);
}
